import { createContext } from 'react'

import { type ReviewTrigger } from '@/lib'

export interface AppReviewContextValue {
  requestReviewPrompt: (trigger: ReviewTrigger) => void
}

export const AppReviewContext = createContext<AppReviewContextValue>({
  requestReviewPrompt: () => {}
})
